(function () {
  /*
    Theme / palette handling now lives entirely in drinksilt-theme.js
    (single source of truth, supports morning | night | both).
    This file owns the mobile drawer, sticky state, and — on
    morning-only pages — keeping the theme hooks off the page.
  */

  var THEME_ATTRIBUTES = ['data-drinksilt-theme', 'data-drinksilt-select'];
  var themeObserver = null;

  function isMorningOnly() {
    return !!(document.body && document.body.classList.contains('silt-morning'));
  }

  /*
    Remove data-drinksilt-theme and data-drinksilt-select from the given
    root (and everything inside it). Defaults to the whole document.
  */
  function stripThemeAttributes(root) {
    if (!isMorningOnly()) {
      return;
    }

    var scope = root || document;

    THEME_ATTRIBUTES.forEach(function (attr) {
      if (scope.hasAttribute && scope.hasAttribute(attr)) {
        scope.removeAttribute(attr);
      }
      if (scope.querySelectorAll) {
        scope.querySelectorAll('[' + attr + ']').forEach(function (el) {
          el.removeAttribute(attr);
        });
      }
    });
  }

  /*
    drinksilt-theme.js can set these attributes after this file runs
    (on load, on saved preference, etc.). Watch for that and remove
    them again as soon as they appear.
  */
  function watchThemeAttributes() {
    if (themeObserver || !isMorningOnly() || !window.MutationObserver) {
      return;
    }

    themeObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          if (mutation.target.hasAttribute(mutation.attributeName)) {
            mutation.target.removeAttribute(mutation.attributeName);
          }
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            stripThemeAttributes(node);
          }
        });
      });
    });

    themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: THEME_ATTRIBUTES,
      childList: true,
      subtree: true
    });
  }

  function initDrawer() {
    var section = document.querySelector('[data-drinksilt-header]');
    if (!section) {
      return;
    }

    var drawer = section.querySelector('[data-drinksilt-menu-drawer]');
    var openButtons = section.querySelectorAll('[data-drinksilt-menu-open]');
    var closeButtons = section.querySelectorAll('[data-drinksilt-menu-close]');

    function openDrawer() {
      if (!drawer) {
        return;
      }
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
    }

    function closeDrawer() {
      if (!drawer) {
        return;
      }
      drawer.hidden = true;
      document.body.style.overflow = '';
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openDrawer);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });

    section.querySelectorAll('.drinksilt-header__drawer-link').forEach(function (link) {
      link.addEventListener('click', closeDrawer);
    });
  }

  /*
    Sticky behaviour lives on the .drinksilt-header-section wrapper in CSS.
    This only adds the scrolled state and publishes the header height so other
    sections (hero offsets, anchor targets) can read it.
  */
  function initSticky() {
    var header = document.querySelector('[data-drinksilt-header]');
    if (!header) {
      return;
    }

    var ticking = false;

    function publishHeight() {
      var height = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        '--drinksilt-header-height',
        Math.round(height) + 'px'
      );
    }

    function syncScrolled() {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(syncScrolled);
      }
    }

    publishHeight();
    syncScrolled();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', publishHeight);

    if (window.ResizeObserver) {
      new ResizeObserver(publishHeight).observe(header);
    }
  }

  function initTheme() {
    stripThemeAttributes();
    watchThemeAttributes();
  }

  function init() {
    initTheme();
    initDrawer();
    initSticky();
  }

  // Start guarding as early as possible if <body> already exists.
  if (document.body) {
    initTheme();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-renders the section without a page reload.
  document.addEventListener('shopify:section:load', function (event) {
    stripThemeAttributes(event.target);
    if (event.target && event.target.querySelector('[data-drinksilt-header]')) {
      init();
    }
  });
})();